import { clsx } from "clsx";
import { ArrowRight } from "lucide-react";
import { useState } from "react";

interface PrimaryCTAProps extends React.ComponentPropsWithoutRef<"button"> {
  showArrow?: boolean;
}

export function PrimaryCTA({
  children,
  onClick,
  className = "",
  showArrow = false,
  ...props
}: PrimaryCTAProps) {
  const [bgColor, setBgColor] = useState("#0247FE");

  return (
    <button
      className={clsx(
        "group inline-flex cursor-pointer items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white shadow-lg transition-all hover:shadow-xl",
        className,
      )}
      style={{ backgroundColor: bgColor }}
      onMouseEnter={() => setBgColor("#0139D1")}
      onMouseLeave={() => setBgColor("#0247FE")}
      onClick={onClick}
      {...props}
    >
      <span>{children}</span>
      {showArrow && (
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      )}
    </button>
  );
}
